import { createAction } from '../../../utils/redux/createAction';
import { SIGN_UP_TYPES } from './constants';

export const signupActions = {
  personalInfoChange: createAction(SIGN_UP_TYPES.PERSONAL_INFO_CHANGE),
  proceed: createAction(SIGN_UP_TYPES.PROCEED),
  confirm: createAction(SIGN_UP_TYPES.CONFIRM),
  reset: createAction(SIGN_UP_TYPES.RESET),
};



// WEBPACK FOOTER //
// ./src/redux/auth/signup/actions.js